import { ENV } from '../../../config/runtimeEnv';
import {
	TestCategory,
	ApiResponse,
	TestCategoryFilters
} from "../../../types/healthcare/TestTypes";
import { http } from "../../../lib/http/client";

const HEALTHCARE_BASE_URL = ENV.VITE_HEALTHCARE_SERVER;

// Get all active test categories for ordering
export const fetchTestCategories = async (filters?: TestCategoryFilters): Promise<ApiResponse<TestCategory[]>> => {
	const params = new URLSearchParams();

	if (filters?.include_test_types) params.append('include_test_types', 'true');

	const response = await http.get(`${HEALTHCARE_BASE_URL}/test-categories?${params.toString()}`);
	return response.data;
};